<template>
  <v-card class="start-xs" style="position: relative">
    <template v-if="integrationType == 'WECHAT' && !isWeChat">
      <div style="padding: 20px 10px 40px">
        <v-icon large style="display: block; margin-bottom: 20px; font-size: 100px; text-align: center" color="primary">
          info
        </v-icon>
        <h3 style="max-width: 220px; margin: auto; text-align: center">
          {{ $vuetify.lang.t('$vuetify.errorReport.invalidWechat') }}
        </h3>
      </div>
    </template>
    <template v-else>
      <v-card-title class="center-xs">
        {{ $vuetify.lang.t('$vuetify.paymentDetails.completePayment') }}
      </v-card-title>
      <form class="FormContainer start-xs">
        <div v-if="showTips" id="tipsContainer">
          <div>
            <b class="pt-3 py-2">
              {{ $vuetify.lang.t('$vuetify.paymentDetails.addTip') }}
            </b>
          </div>

          <br>

          <v-btn-toggle v-if="!showManualTip && !!storeTips && !!storeTips.length" v-model="tipIndex">
            <v-btn class="tipButtons" v-for="tip in storeTips"
              :key="tip.amount"
              @click="showManualTip = false; manulTipAmount = null"
            >
              {{tip.amount}}%
            </v-btn>

            <v-btn class="tipButtons" @click="toggleManual">
              {{ $vuetify.lang.t('$vuetify.common.edit') }}
            </v-btn>
          </v-btn-toggle>

          <v-layout v-else justify-center row wrap id="manualTipRow">
            <v-flex xs10 class="text-xs-center">
              <v-text-field
                name="manualTip"
                type="number"
                prepend-icon="attach_money"
                v-model="manulTipAmount"
                @input="onManualTip"
                @blur="validateManual"
                @keypress="checkNumberRegex"
                onclick="this.select()"
                onfocus="this.select()"
                min="0"
                ref="ManualTipAmount"
                @keyup.enter.prevent="validateManual"
                persistent-placeholder
                placeholder="Enter tip amount"
                :class="{ 'is-empty': manulTipAmount === '' || manulTipAmount === null }"
              />
            </v-flex>

            <v-flex xs2 v-if="storeTips.length" id="closeContainer">
              <v-btn outlined color="primary" @click="toggleManual(false)">
                <!-- <v-icon> -->
                  {{ $vuetify.lang.t('$vuetify.common.cancel') }}
                <!-- </v-icon> -->
              </v-btn>
            </v-flex>
          </v-layout>
        </div>

        <div class="amountDetails">
          <b>{{ $vuetify.lang.t('$vuetify.paymentDetails.subtotal') }}:</b> <span>${{ amount.toFixed(2) }}</span>
        </div>
        <div v-if="showTips" class="amountDetails">
          <b>{{ $vuetify.lang.t('$vuetify.paymentDetails.tip') }}:</b> <span>${{ Number(calcTipAmount()).toFixed(2) }}</span>
        </div>
        <hr>
        <div class="amountDetails">
          <b>{{ $vuetify.lang.t('$vuetify.paymentDetails.total') }}:</b> <span>${{ orderTotal }}</span>
        </div>

        <v-btn color="primary" id="payOrderBtn" @click="payOrder">
          {{ $vuetify.lang.t('$vuetify.checkout.pay') }} (${{ orderTotal }})
        </v-btn>
      </form>
    </template>
  </v-card>
  </template>
  
<script>
  import { mapActions, mapGetters } from 'vuex';
  import { get } from 'lodash'
  import { api } from '@/plugins/api.service'

  export default {
    data: () => ({
      tipIndex: 0,
      showManualTip: false,
      manulTipAmount: '0',
      cardReady: false,
      showTips: true,

      snappyTransactionId: null,
      amount: null,
      orderType: 'PICKUP',
      integrationType: 'WECHAT'
    }),

    computed: {
      isWeChat() {
        const ua = navigator.userAgent.toLowerCase()
        return ua.match(/MicroMessenger/i) == 'micromessenger'
      },

      storeTips() {
        if (this.orderType) {
          return get(this.store, `settings.${this.orderType.toLowerCase()}Settings.tips`, null)
            || this.store.settings.tips
            || this.store.tips
            || []
        } else {  
          return this.store.settings.tips
            || this.store.tips
            || []
        }
      },

      orderTotal() {
        const amount = Number(this.amount) || 0;
        const tip = Number(this.calcTipAmount()) || 0;
        return (amount + tip).toFixed(2);
      },

      ...mapGetters({
        billingInfo: 'getBillingInfo',
        store: 'getStore',
        posSettings: 'getPosSettings'
      })
    },
  
    methods: {
      calcTipAmount(tipsPercent = get(this.storeTips, `[${this.tipIndex}].amount`, 0)) {
        if (this.posSettings && this.posSettings.length) {
          if (
            this.posSettings.includes('WECHAT') &&
            this.posSettings.includes('ALIPAY')
          ) {
            return 0;
          }
          
          if (
            (this.integrationType === 'WECHAT' && this.posSettings.includes('WECHAT')) ||
            (this.integrationType === 'ALIPAY' && this.posSettings.includes('ALIPAY'))
          ) {
            return 0;
          }
        }
        if (this.storeTips.length == 0) {
          this.showManualTip = true;
        }
        if (this.showManualTip && this.manulTipAmount !== null) {
          return this.manulTipAmount
        }
        return +(this.amount * (tipsPercent / 100))
      },
      dollarsToCents: (dollarsAmount) => dollarsAmount*100,
    
      toggleManual(val = !this.showManualTip) {
        this.showManualTip = val
        this.manulTipAmount = 0

        // Default to the first tip on close
        this.$nextTick(() => {
          if (!this.showManualTip) {
            this.findDefault()
          } else {
            this.$refs.ManualTipAmount.focus()
          }
        })
      },
      onManualTip(event) {
        if (event.length == 0) {
          this.$set(this, 'manulTipAmount', '0');
        }
        this.tipsPercent = null
      },
      validateManual() {
        if (!(!this.manulTipAmount || this.manulTipAmount.length == 0 ||  isNaN(this.manulTipAmount))) {
          this.$set(this, 'manulTipAmount', (+this.manulTipAmount).toFixed(2))
        }
      },
      
      findDefault() {
        // Find the selected default tip amount
        let tipIdx = this.storeTips.findIndex(tip => tip.default)

        // If none are found, default to the first
        if (tipIdx < 0)
          tipIdx = 0

        this.tipIndex = tipIdx
      },
      checkNumberRegex(e) {
        if (e.key == '-' || e.key == 'e' || e.key == 'E'){
          e.preventDefault();
        }
        if (e.key === 'Enter' || e.keyCode === 13) {
          e.preventDefault();
          e.target.blur();
          if (typeof this.validateManual === 'function') {
            this.validateManual();
          } else {
            console.warn("validateManual is not defined");
          }
        }
      },

      payOrder() {
        const baseUrl = 
        window.location.hostname.includes('localhost') || window.location.hostname.includes('test.gosnappy.io')
          ? 'https://testpos.gosnappy.io/api/pos'
          : 'https://payment.gosnappy.io/api/pos';

        const payload = {
          "storeId": this.store.storeId,
          "snappyTransactionId": this.snappyTransactionId,
          "amount" : this.dollarsToCents(this.orderTotal),   //in cents, total amount the customer should pay. Include tips
          "tips": this.dollarsToCents(this.calcTipAmount()),   //in cents, represents the tips from the pos client
        }

        return api.post(`${baseUrl}_cloud/v1/payment/pay_wechat_alipay_payment`, payload).then(res => {
          const errorMsg = get(res, 'data.errorMsg') || get(res, 'response.data.errorMsg')
          const errorCode = get(res, 'data.errorCode') || get(res, 'response.data.errorCode')
          const message = errorMsg || errorCode

          if (message) {
            this.$bus.$emit('showAlert', `Error with payment: ${message}`, 'error')
          } else {
            window.location.href = res.data.url
          }
        })
      },
      ...mapActions(['fetchPosSettings'])
    },
  
    mounted() {
      this.integrationType = this.$route.query.integrationType
      this.snappyTransactionId = this.$route.query.snappyTransactionId
      this.amount = (this.$route.query.amount || 0) / 100
      this.orderType = this.$route.query.orderType
      this.fetchPosSettings().then(() => {
        if (this.posSettings && this.posSettings.length) {
          if (this.posSettings.includes('WECHAT') && this.posSettings.includes('ALIPAY')) {
            this.showTips = false; 
          } else if (this.integrationType === 'WECHAT' && this.posSettings.includes('WECHAT')) {
            this.showTips = false; 
          } else if (this.integrationType === 'ALIPAY' && this.posSettings.includes('ALIPAY')) {
            this.showTips = false;
          } else {
            this.showTips = true;
          }
        } else {
          this.showTips = true;
        }
      });
      this.findDefault()
    }
  };
</script>
  

<style scoped>
.v-text-field {
  max-width: 65vw !important;
}
.v-card {
  max-width: 400px;
  margin: 20px auto;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1); /* Subtle shadow */
}

.v-card-title {
  font-size: 22px;
  font-weight: 700;
  text-align: center;
  padding-bottom: 15px;
}

#tipsContainer {
  margin: 15px 0;
  text-align: center;
}

.v-card__title {
  font-size: 20px !important;
  font-weight: 600 !important;

  padding: 10px;
  margin-bottom: 10px;
  background-color: rgb(238,242,244);

  text-align: center !important;
}

.v-btn-toggle {
  display: flex;
  justify-content: center;
  gap: 5px;
}

.v-btn {
  min-width: 80px;
  height: 40px;
  font-size: 16px;
  font-weight: 600; 
  text-transform: none !important;
}

#manualTipRow {
  width: 100%;
  position: relative;
}

.amountDetails>span {
  float: right;
  color: #2c3e50;
}

#closeContainer button {
  min-width: 35px !important;
  height: 35px !important;
}

.amountDetails {
  font-size: 18px;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
  margin: 10px 0;
  width: 100%;
}

hr {
  margin: 10px 0;
  border: none;
  height: 2px;
  background-color: #ddd;
}

#closeContainer {
  display: flex;
  justify-content: center;
  align-items: center;
}

#payOrderBtn {
  width: 100%;
  padding: 12px;
  font-size: 18px;
  font-weight: 700;
  margin-top: 20px;
  border-radius: 8px;
}

#payOrderBtn:hover {
  opacity: 0.9;
}

.v-icon {
  font-size: 80px !important;
  display: block;
  text-align: center;
  margin-bottom: 20px;
}

.tipButtons {
  background-color: white!important;
}

.v-btn-toggle>.v-btn.v-btn--active {
  background: var(--primary-color) !important;
  color: white !important;
}

.v-input.v-input--is-label-active.v-input--is-dirty.theme--light.v-text-field.v-text-field--is-booted {
  max-width: 65vw;
}

</style>
  